/** The address of a saved view's page (2.K stage s2). */
export function viewHref(id: string): string {
  return `/views/${encodeURIComponent(id)}`;
}
